import styled from '@emotion/styled'
import { Colors } from '@/fanmeUi/constant'

const StyledThemeTitle = styled.div<{ type?: string }>`
  width: 100%;
  max-width: 336px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  text-align: center;
  font-family: 'Monsterrat';
  letter-spacing: 5px;
  color: ${props => (props.type === 'Dark' ? Colors.WHITE : Colors.PRIMARY_GRAY)};
  background-color: ${props => (props.type === 'Dark' ? Colors.PRIMARY_GRAY : Colors.WHITE)};
  border: 1px solid ${props => (props.type === 'Dark' ? Colors.WHITE : Colors.PRIMARY_GRAY)};
`

const StyledGridContainer = styled.div`
  width: 100%;
  max-width: 336px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap-reverse;
  flex-direction: row-reverse;
  margin: 24px 0px;
  row-gap: 24px;
`

const StyledGridContainerItem = styled.div`
  width: 25%;
  display: flex;
  justify-content: center;
`

const StyledThemeColorBtn = styled.button<{ background: string; borderColor: string }>`
  width: 64px;
  height: 64px;
  background: ${props => props.background};
  border: ${props => props.borderColor || 'none'};
  border-radius: 12px;
`

export { StyledThemeTitle, StyledGridContainer, StyledGridContainerItem, StyledThemeColorBtn }
